// api/PerfilProfesional.jsx
import apiClient from "@shared/config/axiosConfig";

const PerfilProfesionalService = {
  // Crear perfil profesional
  async crearPerfil(datosPeril) {
    try {
      const response = await apiClient.post(
        "/perfiles-profesionales",
        datosPeril
      );
      return response.data;
    } catch (error) {
      console.error("Error al crear perfil profesional:", error);
      throw error;
    }
  },

  // Obtener todos los perfiles (solo admin)
  async obtenerPerfiles(filtros = {}) {
    try {
      const params = new URLSearchParams();
      if (filtros.departamento)
        params.append("departamento", filtros.departamento);
      if (filtros.experiencia_minima)
        params.append("experiencia_minima", filtros.experiencia_minima);

      const response = await apiClient.get(`/perfiles-profesionales?${params}`);
      return response.data;
    } catch (error) {
      console.error("Error al obtener perfiles profesionales:", error);
      throw error;
    }
  },

  // Obtener mi perfil
  async obtenerMiPerfil() {
    try {
      const response = await apiClient.get("/perfiles-profesionales/mi-perfil");
      // Si la API devuelve { success: true, data: {...} } devolver solo data para consistencia
      return response.data && response.data.data
        ? response.data.data
        : response.data;
    } catch (error) {
      console.error("Error al obtener mi perfil:", error);
      throw error;
    }
  },

  // Actualizar mi perfil
  async actualizarMiPerfil(datos) {
    try {
      const response = await apiClient.put(
        "/perfiles-profesionales/mi-perfil",
        datos
      );
      return response.data;
    } catch (error) {
      console.error("Error al actualizar mi perfil:", error);
      throw error;
    }
  },

  // Obtener perfil por ID
  async obtenerPerfilPorId(idperfil) {
    try {
      const response = await apiClient.get(
        `/perfiles-profesionales/${idperfil}`
      );
      return response.data && response.data.data
        ? response.data.data
        : response.data;
    } catch (error) {
      console.error("Error al obtener perfil por ID:", error);
      throw error;
    }
  },

  // Obtener perfil por usuario
  async obtenerPerfilPorUsuario(idusuario) {
    try {
      const response = await apiClient.get(
        `/perfiles-profesionales/usuario/${idusuario}`
      );
      return response.data && response.data.data
        ? response.data.data
        : response.data;
    } catch (error) {
      console.error("Error al obtener perfil por usuario:", error);
      throw error;
    }
  },

  // Actualizar perfil específico (admin)
  async actualizarPerfil(idperfil, datos) {
    try {
      const response = await apiClient.put(
        `/perfiles-profesionales/${idperfil}`,
        datos
      );
      return response.data;
    } catch (error) {
      console.error("Error al actualizar perfil:", error);
      throw error;
    }
  },

  // Eliminar perfil (solo admin)
  async eliminarPerfil(idperfil) {
    try {
      const response = await apiClient.delete(
        `/perfiles-profesionales/${idperfil}`
      );
      return response.data;
    } catch (error) {
      console.error("Error al eliminar perfil:", error);
      throw error;
    }
  },

  // Obtener perfiles por planta (supervisor y admin)
  async obtenerPerfilesPorPlanta(idplanta = null) {
    try {
      const params = new URLSearchParams();
      if (idplanta) params.append("idplanta", idplanta);

      const response = await apiClient.get(
        `/perfiles-profesionales/por-planta?${params}`
      );
      return response.data;
    } catch (error) {
      console.error("Error al obtener perfiles por planta:", error);
      throw error;
    }
  },

  // Obtener estadísticas (solo admin)
  async obtenerEstadisticas() {
    try {
      const response = await apiClient.get(
        "/perfiles-profesionales/estadisticas"
      );
      return response.data;
    } catch (error) {
      console.error("Error al obtener estadísticas:", error);
      throw error;
    }
  },
};

export default PerfilProfesionalService;
